import { LoaderFunctionArgs } from "react-router";
import { IApiService, LogItem } from "../../../services/ApiService";
import { initLogement } from "../../../dataModel/initLogement";
import { handleLoaderError } from "../../../services/loaderErrorHandler";

export const newLogementPageLoader = (apiService: IApiService) => {
    return async ({ request }: LoaderFunctionArgs) => {
        try {
            const queryStringParams = (new URL(request.url)).searchParams;
            const bailleurIdStr = queryStringParams.get("bailleur") || undefined;
            const currentBailleurId = apiService.getCurrentBailleurId();
            const bailleurId = apiService.isCurrentUserBailleur() ? currentBailleurId : (bailleurIdStr ? parseInt(bailleurIdStr, 10) : undefined);
            if (bailleurId !== undefined && Number.isNaN(bailleurId)) {
                throw new Error("Invalid bailleur id");
            }

            // Lancer fetch parallèles pour optimisation
            const [bailleurs, communes] = await Promise.all([
                apiService.getBailleurs(request.signal),
                apiService.getCommunes(request.signal)
            ]);

            // Logement synchrone
            const logement = initLogement(bailleurId, queryStringParams.get("programme") || undefined);
            const programme = logement.nomProgramme ?? null;
            const logEntries: ReadonlyArray<LogItem> = [];

            return {
                bailleurs,
                programme,
                logement,
                logEntries,
                communes,
                forceProgramme: queryStringParams.has("programme"),
                forceBailleur: apiService.isCurrentUserBailleur() || queryStringParams.has("bailleur")
            };
        } catch (error) {
            return handleLoaderError(error, request.url);
        }
    };
};
